import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { ProtelStatusModel } from 'src/app/shared/models/protel-status-model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProtelStatusService {

  private userToken: string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }

  public GetAll(): Observable<ProtelStatusModel[]> {
    const $this = this;
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.get<ProtelStatusModel[]>(environment.apiUrl + 'api/v1/ProtelStatus', header).pipe();
  }
}
